"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityClass = void 0;
var flApi = require("./flApi");
var RootClass = require("./rootClass");
var EntityClass = (function (_super) {
    __extends(EntityClass, _super);
    function EntityClass(jSonDoc, srvType) {
        if (srvType === void 0) { srvType = 1; }
        var _this = _super.call(this, "entity", jSonDoc, srvType) || this;
        _this._fields = [];
        _this.hasUid = false;
        var monEnt = _this;
        monEnt.eCN = -1;
        monEnt.typeDico = "E";
        return _this;
    }
    Object.defineProperty(EntityClass.prototype, "fields", {
        get: function () {
            return this._fields;
        },
        enumerable: false,
        configurable: true
    });
    EntityClass.prototype.encode = function (jSonData) {
        return _super.prototype.encode.call(this, jSonData);
    };
    EntityClass.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    EntityClass.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    EntityClass.prototype.save = function () {
        return _super.prototype.save.call(this);
    };
    EntityClass.prototype.getField = function (fCN) {
        for (var i = 0; i < this._fields.length; i++) {
            if (this._fields[i].id === fCN) {
                return this._fields[i];
            }
        }
        return null;
    };
    EntityClass.prototype.getFieldByTypes = function (fieldTypesAnyCase) {
        var fieldArr = [];
        var fieldTypes = [];
        fieldTypesAnyCase.forEach(function (aType) {
            fieldTypes.push(aType.toLowerCase());
        });
        for (var i = 0; i < this._fields.length; i++) {
            if (fieldTypes.indexOf(this._fields[i].systemType.toLowerCase()) !== -1) {
                fieldArr.push(this._fields[i]);
            }
        }
        return fieldArr;
    };
    EntityClass.prototype.getFieldByType = function (fieldType) {
        var fieldArr = [];
        fieldType = fieldType.toLowerCase();
        for (var i = 0; i < this._fields.length; i++) {
            if (this._fields[i].systemType.toLowerCase() === fieldType) {
                fieldArr.push(this._fields[i]);
            }
        }
        return fieldArr;
    };
    EntityClass.prototype.getAllRelations = function (remoteCardinalityFilter) {
        if (remoteCardinalityFilter === void 0) { remoteCardinalityFilter = ""; }
        var fieldArr = [];
        for (var i = 0; i < this._fields.length; i++) {
            if (this._fields[i].systemType === "pointer") {
                var fpt = this._fields[i];
                if (remoteCardinalityFilter.length === 0 || fpt.pointer[1].ptCardinality === remoteCardinalityFilter) {
                    fieldArr.push(fpt);
                }
            }
        }
        return fieldArr;
    };
    EntityClass.prototype.postProcess = function () {
        for (var i = 0; i < this._fields.length; i++) {
            this._fields[i].postProcess();
        }
    };
    EntityClass.prototype.removeField = function (fcn) {
        var tmpFields = [];
        this.hasUid = false;
        for (var i = 0; i < this._fields.length; i++) {
            if (this._fields[i].id !== fcn) {
                tmpFields.push(this._fields[i]);
                if (this._fields[i].systemType === "uid") {
                    this.hasUid = true;
                }
            }
        }
        this._fields = tmpFields;
    };
    EntityClass.prototype.addField = function (jSonField) {
        var bFieldThere = this._fields.find(function (f) { return f.id === jSonField.id; }) !== undefined;
        switch (jSonField.c7) {
            case "string":
            case undefined:
                jSonField.c7 = "string";
                var fiStr = new flApi.FieldString("string", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiStr);
                }
                fiStr.postProcess();
                return fiStr;
            case "number":
                jSonField.c7 = "number";
                var fiNbr = new flApi.FieldNumber("number", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiNbr);
                }
                fiNbr.postProcess();
                return fiNbr;
            case "uid":
                var fiUId = new flApi.FieldUserId("uid", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiUId);
                }
                this.hasUid = true;
                fiUId.postProcess();
                return fiUId;
            case "json":
                var fiJson = new flApi.FieldJson("json", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiJson);
                }
                fiJson.postProcess();
                return fiJson;
            case "freejson":
                var fiFreejson = new flApi.FieldFreejson("freejson", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiFreejson);
                }
                fiFreejson.postProcess();
                return fiFreejson;
            case "rollup":
                var fiRol = new flApi.FieldRollup("rollup", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiRol);
                }
                fiRol.postProcess();
                return fiRol;
            case "linkedField":
                var fiLF = new flApi.FieldLinkedField("linkedField", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiLF);
                }
                fiLF.postProcess();
                return fiLF;
            case "pointer":
                var fiPt = new flApi.FieldPointer("pointer", jSonField);
                if (!bFieldThere) {
                    this._fields.push(fiPt);
                }
                fiPt.postProcess();
                return fiPt;
            default:
                throw new Error("Invalid systemType");
        }
    };
    EntityClass.prototype.createNumberField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createStringField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "string"; });
        }
        else {
            jFi.systemType = "string";
        }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createRollupField = function (jRo, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jRo instanceof Array) {
            jRo.forEach(function (aJ) { aJ.systemType = "rollup"; aJ.eCN = 0; });
        }
        else {
            jRo.systemType = "rollup";
            jRo.eCN = 0;
        }
        return this.createField(jRo);
    };
    EntityClass.prototype.createUserIdField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "uid"; });
        }
        else {
            jFi.systemType = "uid";
        }
        this.hasUid = true;
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createJsonField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "json"; });
        }
        else {
            jFi.systemType = "json";
        }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createRollup = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "rollup"; });
        }
        else {
            jFi.systemType = "rollup";
        }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createLinkedField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "linkedField"; });
        }
        else {
            jFi.systemType = "linkedField";
        }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.createPointerField = function (jFi, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        if (jFi instanceof Array) {
            jFi.forEach(function (aJ) { return aJ.systemType = "pointer"; });
        }
        else {
            jFi.systemType = "pointer";
        }
        return this.createField(jFi, delFieldCN);
    };
    EntityClass.prototype.getMergeableEntities = function () {
        var e_1, _a, e_2, _b, e_3, _c;
        var mergeableEnt = [];
        try {
            for (var _d = __values(flApi.Api.getInstance().entities.getAllEntities()), _e = _d.next(); !_e.done; _e = _d.next()) {
                var anEnt = _e.value;
                if (anEnt.id === this.id || anEnt.id < 500) {
                    continue;
                }
                var bFound = false;
                try {
                    for (var _f = (e_2 = void 0, __values(anEnt.fields)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var aField = _g.value;
                        try {
                            for (var _h = (e_3 = void 0, __values(this.fields)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                var myFi = _j.value;
                                try {
                                    if (myFi.singular.toLowerCase() === aField.singular.toLowerCase()) {
                                        mergeableEnt.push(anEnt);
                                        bFound = true;
                                        break;
                                    }
                                    if (bFound) {
                                        break;
                                    }
                                }
                                catch (err) {
                                    continue;
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        if (bFound) {
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return mergeableEnt;
    };
    EntityClass.prototype.deleteCascade = function (bCascade) {
        return this.delete("cascade = true");
    };
    EntityClass.prototype.delete = function (options) {
        if (options === void 0) { options = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var errorDisplay, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorDisplay = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (options.indexOf("NoErrDisplay") !== -1) {
                            errorDisplay = false;
                            options.replace("NoErrDisplay", "");
                        }
                        return [4, this.myApi.restApi.deleteOneDocument(0, this.id, options, this.mymySrvType)];
                    case 2:
                        _a.sent();
                        this.myApi.entities.removeEntityOrField(this.id);
                        return [2];
                    case 3:
                        err_1 = _a.sent();
                        if (errorDisplay) {
                            console.error(err_1.stack || err_1);
                        }
                        err_1 = err_1.stack === undefined ? new Error(err_1) : err_1;
                        throw err_1;
                    case 4: return [2];
                }
            });
        });
    };
    EntityClass.prototype.SubDocumentize = function (jCN, fCN) {
        throw new Error("not yet implemented");
    };
    EntityClass.prototype.createField = function (jFiAny, delFieldCN) {
        if (delFieldCN === void 0) { delFieldCN = -1; }
        return __awaiter(this, void 0, void 0, function () {
            var fieldsToCreate, resp, jFiAnys, fieldsToPush_1, aField_1, srvFields_1, _loop_1, this_1, i, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fieldsToCreate = [];
                        resp = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        jFiAnys = (jFiAny instanceof Array) ? jFiAny : [jFiAny];
                        fieldsToPush_1 = [];
                        jFiAnys.forEach(function (aDocFi) {
                            var myEnti = _this;
                            aDocFi.eCN = myEnti.id;
                            aDocFi.typeDico = "F";
                            if (aDocFi.UI === undefined) {
                                aDocFi.UI = {};
                            }
                            if (aDocFi.singular === undefined) {
                                throw new Error("a singular must be given");
                            }
                            switch (aDocFi.systemType) {
                                case "string":
                                case undefined:
                                    aDocFi.systemType = "string";
                                    aField_1 = new flApi.FieldString("string", aDocFi).toClass();
                                    break;
                                case "number":
                                    aField_1 = new flApi.FieldNumber("number", aDocFi).toClass();
                                    break;
                                case "uid":
                                    aField_1 = new flApi.FieldUserId("uid", aDocFi).toClass();
                                    _this.hasUid = true;
                                    break;
                                case "json":
                                    aField_1 = new flApi.FieldJson("json", aDocFi).toClass();
                                    break;
                                case "freejson":
                                    aField_1 = new flApi.FieldFreejson("json", aDocFi).toClass();
                                    break;
                                case "pointer":
                                    aField_1 = new flApi.FieldPointer("pointer", aDocFi).toClass();
                                    break;
                                case "rollup":
                                    aField_1 = new flApi.FieldRollup("rollup", aDocFi).toClass();
                                    break;
                                case "linkedField":
                                    aField_1 = new flApi.FieldLinkedField("linkedField", aDocFi).toClass();
                                    break;
                                default:
                                    console.error("unknown document in dictionary: " + JSON.stringify(aDocFi));
                                    console.error("skipping this definition");
                                    aField_1 = {};
                                    break;
                            }
                            if (aField_1 !== {}) {
                                fieldsToCreate.push(aField_1.decode());
                                fieldsToPush_1.push(aField_1);
                            }
                        });
                        return [4, this.myApi.restApi.insertDocuments(0, fieldsToCreate, "delField=" + delFieldCN)];
                    case 2:
                        srvFields_1 = (_a.sent());
                        _loop_1 = function (i) {
                            if (this_1.fields.find(function (f) { return f.id === srvFields_1[i].id; }) === undefined) {
                                this_1.fields.push(fieldsToPush_1[i].encode(srvFields_1[i]));
                            }
                            resp.push(this_1.fields[this_1.fields.length - 1]);
                        };
                        this_1 = this;
                        for (i = 0; i < fieldsToPush_1.length; i++) {
                            _loop_1(i);
                        }
                        this.postProcess();
                        return [2, resp];
                    case 3:
                        err_2 = _a.sent();
                        console.error(err_2.stack || err_2);
                        err_2 = err_2.stack === undefined ? new Error(err_2) : err_2;
                        throw err_2;
                    case 4: return [2];
                }
            });
        });
    };
    EntityClass.prototype.toClass = function () {
        return this;
    };
    return EntityClass;
}(RootClass.RootClass));
exports.EntityClass = EntityClass;
